import type { IconData } from '@stacksjs/iconify-core'

export const shoppingCart: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3 0H0v2h2v10h8a6 6 0 0 0 6-6V2H5a2 2 0 0 0-2-2m2 14.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0M7.5 16a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default shoppingCart
